

import { isEmpty, split } from 'lodash';

// define a mixin object
export default {
  props: {
    cols: {
      default: 12,
      required: false,
    },
    rows: {
      default: 1,
      required: false,
    },
    hidden: {
      required: false,
      type: String,
      default: null,
    },
  },

  computed: {
    gridExpanded: function () {
      return false;
    },
    gridClasses: function () {
      if (this.gridExpanded) {
        return 'col-12 row-start-1';
      }

      return `${split(this.cols, ' ')
        .filter(i => !isEmpty(i))
        .map(i => `col-${i}`)
        .join(' ')
      } ${split(this.rows, ' ')
        .filter(i => !isEmpty(i))
        .map(i => `row-${i}`)
        .join(' ')
      } ${split(this.hidden, ' ')
        .filter(i => !isEmpty(i))
        .map(i => `hidden@${i}`)
        .join(' ')
      }`;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/GridMixin.js